var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 35c2.07 0 3.75-1.68 3.75-3.75v-10c0-2.07-1.68-3.75-3.75-3.75H30v-5c0-2.758 2.242-5 5-5h.625A1.87 1.87 0 0 0 37.5 5.625v-3.75A1.87 1.87 0 0 0 35.625 0H35c-6.906 0-12.5 5.594-12.5 12.5v18.75c0 2.07 1.68 3.75 3.75 3.75h10zm-22.5 0c2.07 0 3.75-1.68 3.75-3.75v-10c0-2.07-1.68-3.75-3.75-3.75H7.5v-5c0-2.758 2.242-5 5-5h.625A1.87 1.87 0 0 0 15 5.625v-3.75A1.87 1.87 0 0 0 13.125 0H12.5C5.594 0 0 5.594 0 12.5v18.75C0 33.32 1.68 35 3.75 35h10z",
    fill: "#3E704B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote-left.7c44f8d0.svg";
export { ForwardRef as ReactComponent };